<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon ion-icon"
    viewBox="0 0 512 512"
  >
    <title>List</title>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M160 144h288M160 256h288M160 368h288"
    />
    <circle
      cx="80"
      cy="144"
      r="16"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <circle
      cx="80"
      cy="256"
      r="16"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <circle
      cx="80"
      cy="368"
      r="16"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
</template>
